import { type ReactElement } from 'react';
import { fbaHooks } from '@flatbiz/antd';
import { type BootstrapOptions, type LayoutCtxProps } from '../types/layout.js';
import { type BreadConfigItem } from '../types/route.js';

export const [useLayoutCtx, LayoutProvider] =
  fbaHooks.createCtx<LayoutCtxProps>();
export const [bootstrapCtx, BootstrapCtx] = fbaHooks.createCtx<{
  breads: BreadConfigItem[];
  breadTitle?: string | ReactElement;
  breadcrumbProps?: LayoutCtxProps['breadcrumbProps'];
  layoutMode: BootstrapOptions['layoutMode'];
}>();
